import _ from 'lodash';
import chartColors from '../../../shared/js/lib/chartColors';
import DashboardNavigation from '../components/DashboardNavigation';
import React, { PropTypes } from 'react';
import { Bar, Doughnut, HorizontalBar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import dashboardCharts from '../lib/dashboardCharts';

let DashboardStudentDetails = React.createClass({
	propTypes: {
		observation: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
		studentEventTypes: PropTypes.array,
		studentId: PropTypes.number.isRequired
	},

	getInitialState: function() {
		return {
			student: null
		};
	},

	componentWillMount: function() {
		this.setStudentInState(this.props.studentId);
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.studentId !== this.props.studentId) {
			this.setStudentInState(newProps.studentId);
		}
	},

	setStudentInState: function(studentId) {
		let student = null;

		this.props.observation.student_observations.every((studentObservation) => {
			if (studentObservation.student && studentObservation.student.id === studentId) {
				student = studentObservation.student;
				return false;
			} else {
				return true;
			}
		});

		this.setState({ student });
	},

	getStudentObservations: function() {
		return this.props.observation.student_observations.filter((studentObservation) => {
			return studentObservation.student_id === this.props.studentId;
		});
	},

	getDistanceChartData: function() {
		return {
			labels: ['CM-CF', 'CM-MF', 'TM-CF', 'TM-MF'],
			datasets: [
				{
					label: 'Recommended',
					backgroundColor: chartColors.cyan,
					data: [
						this.state.student.recommended_CMCF_minutes,
						this.state.student.recommended_CMMF_minutes,
						this.state.student.recommended_TMCF_minutes,
						this.state.student.recommended_TMMF_minutes
					]
				},
				{
					label: 'Observed',
					backgroundColor: chartColors.yellow,
					data: [
						this.getInstructionTypeDuration('Peers', 'CF') + this.getInstructionTypeDuration('Alone', 'CF'),
						this.getInstructionTypeDuration('Peers', 'MF') + this.getInstructionTypeDuration('Alone', 'MF'),
						this.getInstructionTypeDuration('Teacher', 'CF'),
						this.getInstructionTypeDuration('Teacher', 'MF')
					]
				},
				{
					label: 'Off task',
					backgroundColor: chartColors.red,
					data: [
						this.getOffTaskDuration('Peers', 'CF') + this.getOffTaskDuration('Alone', 'CF'),
						this.getOffTaskDuration('Peers', 'MF') + this.getOffTaskDuration('Alone', 'MF'),
						this.getOffTaskDuration('Teacher', 'CF'),
						this.getOffTaskDuration('Teacher', 'MF')
					]
				}
			]
		};
	},

	getDistanceChartOptions: function() {
		return {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				position: 'bottom',
				labels: {
					fontSize: 14
				}
			},
			title: {
				display: false
			},
			plugins: {
				datalabels: {
					color: '#333',
					font: {
						weight: 'bold',
						size: 16
					},
					render: 'value',
					anchor: 'center',
					align: 'center',
					clamp: true,
					formatter: dashboardCharts.formatDecimal
				}
			},
			scales: {
				yAxes: [{
					ticks: {
						min: 0,
						max: this.getMaxDistanceMinutes()
					}
				}]
			},
			tooltips: {
				callbacks: {
					title: (tooltipItems, data) => {

						return data.datasets[tooltipItems[0].datasetIndex].label + ' ' + tooltipItems[0].label.replace(/ , /, '') + ' minutes';
					},
					label: (tooltipItem, data) => {
						return dashboardCharts.formatDecimal(tooltipItem.yLabel);
					}
				}
			}
		};
	},

	getInstructionTypeDuration: function(management, instructionType) {
		let duration = 0;

		const studentObservations = this.props.observation.student_observations.filter((studentObservation) => {
			return studentObservation.student_id === this.state.student.id &&
				studentObservation.observation_subject.description === 'Literacy';
		});

		studentObservations.map((studentObservation) => {
			if (
				studentObservation.observation_management.description === management &&
				studentObservation.observation_instruction_type.abbreviation === instructionType
			) {
				duration += dashboardCharts.getDuration(studentObservation);
			}
		});

		return duration;
	},

	getOffTaskDuration: function(management, instructionType) {
		let duration = 0;

		const studentObservations = this.props.observation.student_observations.filter((studentObservation) => {
			return studentObservation.student_id === this.state.student.id &&
				studentObservation.observation_subject.description === 'Literacy';
		});

		studentObservations.map((studentObservation) => {
			if (
				studentObservation.observation_management.description === management &&
				studentObservation.observation_instruction_type.abbreviation === instructionType &&
				studentObservation.student_behavior_type.description === 'Off task'
			) {
				duration += dashboardCharts.getDuration(studentObservation);
			}
		});

		return duration;
	},

	getMaxDistanceMinutes: function() {
		const maxMinutes = Math.max(this.props.observation.student_minutes, this.state.student.recommended_CMCF_minutes, this.state.student.recommended_CMMF_minutes, this.state.student.recommended_TMCF_minutes, this.state.student.recommended_TMMF_minutes);

		return Math.ceil(maxMinutes / 10) * 10;
	},

	render: function() {
		return (
			<div className="observation-overview">
				<div className="row observation-dashboard-header">
					<div className="col-lg-8">
						<h2>
							Student Details: { this.state.student.first_name + ' ' + this.state.student.last_name }
						</h2>
					</div>
					<div className="col-lg-4">
						<DashboardNavigation observation={ this.props.observation } router={ this.props.router } />
					</div>
				</div>

				<div className="row">
					<div className="col-lg-6">
						<div className="dashboard-card chart-card">
							<h3>Distance from Recommendation</h3>
							<p>Minutes of Instruction</p>
							<div className="chart-container">
								<Bar
									data={ this.getDistanceChartData() }
									options={ this.getDistanceChartOptions() }
								/>
							</div>
						</div>
					</div>


					<div className="col-lg-6">
						<div className="dashboard-card chart-card">
							<h3>Content</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<Doughnut
									data={ dashboardCharts.getDoughnutChartData(this.getStudentObservations(this.state.student.id), 'observation_subject') }
									options={ dashboardCharts.getDoughnutChartOptions() }
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Literacy</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getLiteracyBreakdownChartData(this.getStudentObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.student_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Math</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getMathBreakdownChartData(this.getStudentObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.student_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Other</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getOtherBreakdownChartData(this.getStudentObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.student_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-lg-2" />
					<div className="col-lg-8">
						<div className="dashboard-card chart-card">
							<h3>Student Moves</h3>
							<p>Observed Occurrences</p>
							<div className="chart-container" style={ { height: '500px' } }>
								<HorizontalBar
									data={ dashboardCharts.getStudentMovesChartData(this.props.studentEventTypes, this.getStudentObservations()) }
									options={ dashboardCharts.getMovesChartOptions() }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-2" />
				</div>
			</div>
		);
	}
});

module.exports = DashboardStudentDetails;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/DashboardStudentDetails.jsx